import React from 'react';
import "./../../ReportView/ReportDetailContainer/ReportDetailContainer.scss"
import { DetailsList, DetailsListLayoutMode, Selection, SelectionMode, IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import DetailViewOverlay from "./../../DetailView/DetailViewOverlay"
import { queryDeleteDtmfEntry, queryReportData } from "../../../queries/queryReport";
import { MarqueeSelection } from 'office-ui-fabric-react/lib/MarqueeSelection';
import { Dialog, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { CommandBarButton } from 'office-ui-fabric-react/lib/Button';
import { FontSizes, Stack, Text } from 'office-ui-fabric-react/lib';
import { Depths } from '@uifabric/fluent-theme/lib/fluent/FluentDepths';
import { Fabric } from 'office-ui-fabric-react/lib/';

import zipcelx from 'zipcelx';
import { MyContext } from '../../../context';
import { toast } from 'react-toastify';

const config = {
    filename: 'report',
    sheet: {
        data: [
            [
                {
                    value: "id",
                    type: 'string'
                }, {
                    value: "tenantId",
                    type: 'string'
                }, {
                    value: "creationDate",
                    type: 'string'
                }, {
                    value: "pstnNumber",
                    type: 'string'
                }, {
                    value: "endDate",
                    type: 'string'
                }
            ]
        ]
    }
};

export interface IDocument {
    id: String,
    tenantId: String,
    pstnNumber: String,
    endDate: String
}

export interface IDetailsListDocumentsExampleState {
    columns: IColumn[];
    items: IDocument[];
    selectionDetails: string;
    isModalSelection: boolean;
    isCompactMode: boolean;
}



export default class ReportDtmfContainer extends React.Component<{}, IDetailsListDocumentsExampleState> {
    _selection: Selection;
    _allItems: IDocument[];
    constructor(props: {}) {
        super(props);

        this.detailContainerRef = React.createRef();

        this._allItems = _generateDocuments(props.data.dtmfEntries);

        const columns: IColumn[] = [
            {
                key: 'column1',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("detailContainer", "id")}</>)}</MyContext.Consumer>,
                fieldName: 'id',
                minWidth: 200,
                maxWidth: 400,
                isRowHeader: true,
                isResizable: true,
                isSorted: true,
                isSortedDescending: false,
                sortAscendingAriaLabel: 'Sorted A to Z',
                sortDescendingAriaLabel: 'Sorted Z to A',
                onColumnClick: this._onColumnClick,
                data: 'string',
                onRender: (item: IDocument) => {
                    return <span>{item.id}</span>;
                }
            },
            {
                key: 'column3',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("compliance", "creationDate")}</>)}</MyContext.Consumer>,
                fieldName: 'creationDate',
                minWidth: 120,
                maxWidth: 200,
                isResizable: true,
                data: 'string',
                onColumnClick: this._onColumnClick,
                onRender: (item: IDocument) => {
                    return <span>{item.creationDate}</span>;
                }
            }
            , {
                key: 'column4',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "pstnNumber")}</>)}</MyContext.Consumer>,
                fieldName: 'pstnNumber',
                minWidth: 200,
                maxWidth: 250,
                isResizable: true,
                data: 'string',
                onColumnClick: this._onColumnClick,
                onRender: (item: IDocument) => {
                    return <span>{item.pstnNumber}</span>;
                }
            }
            ,
            {
                key: 'column5',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "endDate")}</>)}</MyContext.Consumer>,
                fieldName: 'endDate',
                minWidth: 120,
                maxWidth: 200,
                isResizable: true,
                data: 'string',
                onColumnClick: this._onColumnClick,
                onRender: (item: IDocument) => {
                    return <span>{item.endDate}</span>;
                },
            },


        ];
        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({
                    selectionDetails: this._getSelectionDetails()
                });
            }
        });

        this.state = {
            items: this._allItems,
            columns: columns,
            selectionDetails: this._getSelectionDetails(),
            isModalSelection: true,
            isCompactMode: false,
            isDialogOpen: false
        };

    }

    _onExport = (ev) => {
        var itemList = [];
        itemList.push(config.sheet.data[0].slice());
        this.state.items.forEach((anItem) => {
            itemList.push([
                {
                    value: anItem.id,
                    type: 'string'
                }, {
                    value: anItem.tenantId,
                    type: 'string'
                }, {
                    value: anItem.creationDate,
                    type: 'string'
                }, {
                    value: anItem.pstnNumber,
                    type: 'string'
                }, {
                    value: anItem.endDate,
                    type: 'string'
                }]);
        });
        config.sheet.data = itemList;
        zipcelx(config)
        this.setState({ isDialogOpen: true });
    }



    _dialogClose = () => this.setState({ isDialogOpen: false })


    _onDelete = async () => {
        const selectedItems = this._selection.getSelection();
        if (selectedItems.length === 0) return;

        const item = selectedItems[0];

        let data = await this.props.apol.mutate({
            mutation: queryDeleteDtmfEntry,
            refetchQueries: [{
                query: queryReportData,
                variables: { input: this.props.authorization, id: this.props.data.id },
            }],
            variables: {
                id: item.id,
                pstnNumber: item.pstnNumber
            }
        });

        if (data.data.deleteDtmfEntry && data.data.deleteDtmfEntry.id !== 'error') {
            const newItems = this.state.items.filter(i => i.id !== item.id);
            this._allItems = this._allItems.filter(i => i.id !== item.id);
            this.setState({ items: newItems });
            this._selection.setAllSelected(false);
        } else {
            toast.error("Error deleting DTMF entry. Please try again.");
        }
    }

    render() {
        const { columns, items, isModalSelection } = this.state;
        const gridStyles: Partial<IDetailsListStyles> = {
            root: {
                overflowX: 'scroll',
                selectors: {
                    '& [role=grid]': {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'start',
                        height: window.innerHeight - 100,
                    },
                },
            },
            headerWrapper: {
                flex: '0 0 auto',
            },
            contentWrapper: {
                flex: '1 1 auto',
                overflowY: 'auto',
                overflowX: 'hidden',
            },
        };
        return (<MyContext.Consumer>
            {(context) => (
                <Fabric>
                    <DetailViewOverlay authorization={this.props.authorization} client={this.props.apol} ref={this.detailContainerRef} loading={true} userRules={this.props.userRules} theme={this.props.theme} />

                    <Dialog
                        isOpen={this.state.isDialogOpen}
                        type={DialogType.close}
                        onDismiss={this._dialogClose.bind(this)}
                        title={context.getTranslation("detailContainer", "excelExport")}
                        subText={context.getTranslation("detailContainer", "excelExportMessage")}
                        isBlocking={false}
                        closeButtonAriaLabel='Close'
                    />
                    <header className="report-panel-header ms-Grid-row" style={{ boxShadow: Depths.depth8 }}>

                        <Stack horizontal>

                            <Text style={{ padding: "5px" }} >{context.getTranslation("detailContainer", "report")}  {this.props.data.title}{this.props.data.overflow && ": Data Overflow"}</Text>

                            <Stack.Item grow={2} ><div /></Stack.Item>

                            <SearchBox
                                placeholder="Search"
                                onChange={(event, newValue) => {
                                    if (event != null) event.persist();
                                    this.setState({
                                        items: newValue ? this._allItems.filter(i => (i.text.toLowerCase().indexOf(newValue.toLowerCase()) > -1 || i.title.toLowerCase().indexOf(newValue.toLowerCase()) > -1 || i.conversationId.toLowerCase().indexOf(newValue.toLowerCase()) > -1 || i.userLogin.toLowerCase().indexOf(newValue.toLowerCase()) > -1)) : this._allItems
                                    });
                                }}
                            />
                            <CommandBarButton
                                iconProps={{ iconName: 'Download' }}
                                text={context.getTranslation("detailContainer", "exportReport")}
                                style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.Icon }}
                                onClick={this._onExport}
                            />
                        </Stack>
                    </header>
                    <div className="report-details-wrapper">

                        {/* == Player and meta data. ===================================== */}

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">

                                    <CommandBarButton
                                        iconProps={{ iconName: 'Delete' }}
                                        text={context.getTranslation("common", "deleteEntry")}
                                        style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.Icon }}
                                        onClick={this._onDelete}
                                        disabled={this._selection.getSelectedCount() === 0}
                                    />

                                <MarqueeSelection selection={this._selection}>
                                    <DetailsList
                                        items={items}
                                        columns={columns}
                                        selectionMode={isModalSelection ? SelectionMode.single : SelectionMode.none}
                                        setKey="set"
                                        layoutMode={DetailsListLayoutMode.fixedColumns}
                                        isHeaderVisible={true}
                                        selection={this._selection}
                                        selectionPreservedOnEmptyClick={true}
                                        enterModalSelectionOnTouch={true}
                                        ariaLabelForSelectionColumn="Toggle selection"
                                        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                    />
                                </MarqueeSelection>
                            </div> {/* end of main contenten */}
                        </div>
                    </div>
                </Fabric>
            )
            }
        </MyContext.Consumer>);

    }
    componentDidUpdate(previousProps: any, previousState: IDetailsListDocumentsExampleState) {
        if (previousState.isModalSelection !== this.state.isModalSelection && !this.state.isModalSelection) {
            this._selection.setAllSelected(false);
        }
    }

    _getSelectionDetails(): string {
        const selectionCount = this._selection.getSelectedCount();

        switch (selectionCount) {
            case 0:
                return 'No items selected';
            case 1:
                return '1 item selected: ' + (this._selection.getSelection()[0]).name;
            default:
                return `${selectionCount} items selected`;
        }
    }


    _onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const { columns, items } = this.state;
        const newColumns: IColumn[] = columns.slice();
        const currColumn: IColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
        newColumns.forEach((newCol: IColumn) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        const newItems = _copyAndSort(items, currColumn.fieldName, currColumn.isSortedDescending);
        this.setState({
            columns: newColumns,
            items: newItems
        });
    };
}



function _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
    const key = columnKey;
    return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
}

function _generateDocuments(DataArr) {
    const items: IDocument[] = [];
    if (DataArr !== undefined) {
        for (let i = 0; i < DataArr.length; i++) {
            items.push({
                id: DataArr[i].id,
                tenantId: DataArr[i].tenantId,
                creationDate: DataArr[i].creationDate,
                pstnNumber: DataArr[i].pstnNumber,
                endDate: DataArr[i].endDate,

            })
        }
    }
    return items;
}


